import React from 'react';
import useReveal from '../hooks/useReveal';
import ContactUsSection from '../Components/ContactUsSection';

const Contact = () => {
    useReveal();

    return (
        <div>
            <ContactUsSection />
        </div>
    );
};

export default Contact;
